import React from "react";
import { svg } from "../../../../../../../../assets/svg";

export function CompleteIcon({ isCompleted }) {
  if (isCompleted === 0) {
    return <span>-</span>;
  }

  return (
    <img
      src={isCompleted > 0 ? svg.checkCircleGreen : svg.crossCircleRed}
      width="20px"
      alt=""
    />
  );
}
